import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import agentService from '../services/agentService';
import { queryKeys } from './queryKeys';

const agentsListDefaults = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  refetchOnMount: 'always',
};

/**
 * Shared user-created agents list. Same cache for SideBar, Agents page, modals, etc.
 */
export function useAgents(options = {}) {
  return useQuery({
    queryKey: queryKeys.agents.all,
    queryFn: () => agentService.getAllAgent(),
    ...agentsListDefaults,
    ...options,
  });
}

export function useFeedaAgents(options = {}) {
  return useQuery({
    queryKey: queryKeys.agents.feeda,
    queryFn: () => agentService.getAllfeedaAgents(),
    staleTime: 30_000,
    refetchOnMount: 'always',
    ...options,
  });
}

export function useAgentDetail(agentId, options = {}) {
  return useQuery({
    queryKey: queryKeys.agents.detail(agentId),
    queryFn: () => agentService.getAgentDetail(agentId),
    enabled: !!agentId,
    ...options,
  });
}

export function useModels(options = {}) {
  return useQuery({
    queryKey: queryKeys.models.all,
    queryFn: () => agentService.getAllModels(),
    staleTime: Infinity,
    ...options,
  });
}

export function useDeleteAgent(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id => agentService.deleteAgent(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.agents.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useCreateAgent(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => agentService.createAgent(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.agents.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateAgent(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => agentService.EditAgent(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.agents.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
